export type Prefix = string;
export type ASN = number;

export enum IpVersion {
  V4 = 'v4',
  V6 = 'v6',
}

export const getIpVersion = (prefix: Prefix) => (prefix.includes(':') ? IpVersion.V6 : IpVersion.V4);

export async function getData<T extends object>(name: string, params?: GetDataParams): Promise<T> {
  const queryParams = new URLSearchParams(params ?? {});

  const response = await fetch(`https://stat.ripe.net/data/${name}/data.json?${queryParams.toString()}`);
  const parsedBody = (await response.json()) as ResponseBody;

  if ('ok' !== parsedBody.status) {
    throw new RipeRequestFailedError(parsedBody);
  }

  return parsedBody.data as T;
}

export class RipeRequestFailedError extends Error {
  public readonly responseBody?: ResponseBody;

  constructor(responseBody?: ResponseBody) {
    super('RIPE API Request failed');

    this.responseBody = responseBody;
  }
}

type GetDataParams = { [key: string]: string };

interface ResponseBody {
  status: 'ok' | 'error' | 'maintenance';
  data: object;
}
